import { User } from "@coworker/apprestructured/src/shared/types/user";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { StoreTeam } from "@coworker/types/lib/storeteam";
import { NoSearchResults } from "../NoSearchResults/NoSearchResults";
import { useTranslation } from "@coworker/locales";
import { Loading } from "../Loading/Loading";

type UsersListProps = {
  matchingUsers: User[];
  isLoading: boolean;
  teams: StoreTeam[];
  searchQuery: string;
  assignedUserId: string | null;
  onUserIdChange: (assignedUserId: string) => void;
  onSearchForTeamsClick: () => void;
  onClearSearchClick: () => void;
};

export const UsersList = (props: UsersListProps) => {
  const { t } = useTranslation();

  return props.isLoading ? (
    <Loading />
  ) : (
    <FixaListView id="coworkers">
      {props.matchingUsers.map((user) => (
        <FixaListViewItem
          key={user.uid}
          avatarProps={{
            text: `${user.firstName?.slice(0, 1)}${user.lastName?.slice(0, 1)}`,
            screenReaderText: user.fullName,
          }}
          emphasised
          title={user.fullName}
          description={
            props.teams.find((team) => team.id === user.teamId)?.name ?? ""
          }
          control="radiobutton"
          controlProps={{
            checked: user.uid === props.assignedUserId,
            value: user.uid,
          }}
          onChange={() => props.onUserIdChange(user.uid)}
        />
      ))}
      {props.matchingUsers.length === 0 && (
        <NoSearchResults
          searchQuery={props.searchQuery}
          searchTarget={t("teamsString")}
          onSearchForClick={props.onSearchForTeamsClick}
          clearSearch={props.onClearSearchClick}
        />
      )}
    </FixaListView>
  );
};
